
import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import customerDatas from '../datas/customer'
import { getnameMapEnglish } from 'enumeration/lab-order.js'
import { getEnumeration } from 'enumeration'
import { organizationRoleType } from 'json/customer-options'
import timeutils from 'utils/wt-time-utils'
import { formatDate } from '@/utils/formUtils'
import { sexArr } from 'json/customer-options'
let customerAction = {
  systemCustomerList(ctx, data) {
    return fetch.systemCustomerList(data).then(res => {
      res.data.forEach(ele => {
        ele.gender = ele.gender ? getnameMapEnglish(ele.gender) : ''
        ele.roleDisplayName = ele.roleDisplayName ? ele.roleDisplayName.map(e => e).toString() : ''
        ele.departmentDisplayName = ele.departmentDisplayName ? ele.departmentDisplayName.map(e => e).toString() : ''
      })
      let result = getTotalNumber(res)
      return result
    })
  },
  getVendors(ctx, data) {
    return fetch.getVendors(data).then(res => {
      res.data.forEach(ele => {
        ele.isType = ele.type === 'TENANT' ? '是' : '否'
        ele.createdDate = timeutils.format(ele.createdDate, 'date')
        ele.identificationNumber = ele.identificationNumber ? ele.identificationNumber : '--'
        ele.rolesCopy = ele.roles ? ele.roles.map(e => getEnumeration(e, organizationRoleType)).toString() : '--'
      })
      let result = getTotalNumber(res)
      return result
    })
  },
  getOrganizationsCustomer (ctx) {
    return fetch.getOrganizations().then(res => {
      let result = customerDatas.getOrganizations(res.data)
      return result
    })
  },
  rolesList (ctx, data) {
    return fetch.rolesList(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  createdOrgCustomer (ctx, data) {
    return fetch.createdOrgCustomer(data).then(res => {
      return res.data
    })
  },
  organizationUserInformation (ctx, userLogin) {
    const data ={
      userLogin
    }
    return fetch.organizationUserInformation(data).then(res => {
      res.data.organizationUser.gender_text = getEnumeration(res.data.organizationUser.gender, sexArr)
      res.data.organizationUser.last_modified_date = formatDate(res.data?.organizationUser?.lastModifiedDate)
      res.data.organizationUser.created_date = formatDate(res.data?.organizationUser?.createdDate)
      return res.data
    })
  },
  deleteOrganizationUser (ctx, data) {
    return fetch.deleteOrganizationUser(data).then(res => {
      return res.data
    })
  },
  updateOrganizationUser (ctx, data) {
    return fetch.updateOrganizationUser(data).then(res => {
      return res.data
    })
  },
  rolesStatistics (ctx, data) {
    return fetch.rolesStatistics(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  getPermissionsList (ctx, data) {
    return fetch.getPermissionsList(data).then(res => {
      let result = res.data
      return result
    })
  },
  createdRoles (ctx, data) {
    return fetch.createdRoles(data).then(res => {
      return res.data
    })
  },
  rolesDetail (ctx, name) {
    return fetch.rolesDetail(name).then(res => {
      return res.data
    })
  },
  rolesDelete (ctx, id) {
    return fetch.rolesDelete(id).then(res => {
      return res.data
    })
  },
  rolesEdit (ctx, data) {
    return fetch.rolesEdit(data).then(res => {
      return res.data
    })
  },
  // LH---------
  getOrganizationsList (ctx, data) {
    return fetch.getOrganizationsList(data).then(res => {
      res.data.forEach(ele => {
        ele.isType = ele.type === 'TENANT' ? '是' : '否'
        ele.created_date = timeutils.format(ele.createdDate, 'date')
        ele.identificationNumber = ele.identificationNumber ? ele.identificationNumber : '--'
        ele.rolesCopy = ele.roles ? ele.roles.map(e => getEnumeration(e, organizationRoleType)).toString() : '--'
        ele.fullName = ele.fullName ? ele.fullName : '--'
      })
      let result = getTotalNumber(res)
      return result
    })
  },
  createOrganization (ctx, data) {
    return fetch.createOrganization(data).then(res => {
      return res.data
    })
  },
  updateVendor (ctx, data) {
    return fetch.updateVendor(data).then(res => {
      return res.data
    })
  },
  getVendor (ctx, id) {
    return fetch.getVendor(id).then(res => {
      res.data.rolesCopy = res.data.roles ? res.data.roles.map(e => getEnumeration(e, organizationRoleType)).toString() : '--'
      return res.data
    })
  },
  deleteVendor (ctx, id) {
    return fetch.deleteVendor(id).then(res => {
      return res.data
    })
  },
  getPrimaryOrganization (ctx) {
    return fetch.getPrimaryOrganization().then(res => {
      return res.data
    })
  },
  getAllExamBasis (ctx) {
    return fetch.getAllExamBasis().then(res => {
      return res.data
    })
  },
  getOffices (ctx, data) {
    return fetch.getOffices(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
}
export default customerAction
